import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1100443e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ob ob-off",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-wifi-off ob-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = { class: "ob-text" }
const _hoisted_4 = {
  key: 1,
  class: "ob ob-on",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-wifi ob-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = { class: "ob-text" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x-lg",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "ob-fade" }, {
    default: _withCtx(() => [
      (_ctx.isOffline)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("offline.title")), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.savedAt ? _ctx.$t("offline.savedAt", {time: _ctx.savedTime}) : _ctx.$t("offline.noData")), 1)
            ])
          ]))
        : (_ctx.justRestored)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("offline.restored")), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("offline.restoredText")), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light ob-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
              }, _toDisplayString(_ctx.$t("offline.refresh")), 1),
              _createElementVNode("button", {
                type: "button",
                class: "ob-close",
                "aria-label": _ctx.$t('offline.close'),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
              }, _hoisted_9, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}